/** Runtime config loaded from public/config.js (window.__APP_CONFIG__). */

export const getApiBaseUrl = () => {
  const url = window.__APP_CONFIG__?.API_BASE_URL;
  if (!url || !String(url).trim()) {
    console.error('API_BASE_URL is not set in config.js');
    return '';
  }
  return String(url).trim().replace(/\/$/, '');
};

export const getImageBaseUrl = () => {
  const imageUrl = window.__APP_CONFIG__?.IMAGE_BASE_URL;
  if (imageUrl && String(imageUrl).trim()) {
    return String(imageUrl).trim().replace(/\/$/, '');
  }
  const apiBase = getApiBaseUrl();
  return apiBase ? apiBase.replace(/\/api\/?$/, '') : '';
};

export const getImageSrc = (url) => {
  if (!url) return '';
  if (url.startsWith('http') || url.startsWith('data:')) return url;
  const base = getImageBaseUrl();
  return `${base}${url.startsWith('/') ? url : `/${url}`}`;
};
